import { EnumContainerActionRequest } from '@Model';
import { Button, FlexRow, iconSizeXs, useTranslate } from '@synqo/frontend-component-library';
import { IconPlus } from '@tabler/icons-react';

interface ContainerActionButtonsProps {
    locked: boolean;
    lockedReason?: string;
    onPlan: (action: EnumContainerActionRequest) => void;
}

/** The button in the header of the container card that plans a placement; everything else starts at the site. */
// @ai-generated 2026-10-08T19:12:01+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function ContainerActionButtons({ locked, lockedReason, onPlan }: ContainerActionButtonsProps) {
    const i18n = useTranslate('');

    return (
        <FlexRow gap="xs">
            <Button
                appearance="dashed"
                size="xs"
                tooltip={lockedReason}
                locked={locked}
                onClick={() => onPlan(EnumContainerActionRequest.Place)}
            >
                <IconPlus size={iconSizeXs} />
                &nbsp;{i18n('Container stellen')}
            </Button>
        </FlexRow>
    );
}
